import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = {
  key: 0,
  class: "card-body p-3"
}
const _hoisted_3 = {
  key: 1,
  class: "card-body p-3"
}
const _hoisted_4 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_5 = { class: "col-md-1" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = { class: "col-md-12 table-responsive" }
const _hoisted_13 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "row mb-2" }
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "text-danger fw-bold" }

import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/vouchersService";
import { fdata, fdataHora, fdataUS } from "@/utils/funcoes";

//componentes
import TrataTecla from "@/components/TrataTecla/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";

interface IProps {
  ClienteId?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientesVouchers',
  props: {
    ClienteId: {}
  },
  setup(__props: any) {


//vue
var props = __props;

var controle = reactive({
  clienteId: props.ClienteId as number | null | undefined,
  indicados: [] as service.Voucher[],
  clienteIndicou: {} as service.Voucher,

  model: {
    indicadorId: props.ClienteId
  } as service.Voucher,
  janela: false,
  janPergunta: false,
  erro: "",
  status: ""
})

onMounted(() => {

  buscarIndicador();
  buscarIndicados();

});

watch(() => props.ClienteId, (newValue) => {
  controle.clienteId = newValue;
  controle.model.indicadorId = newValue ?? 0;
  buscarIndicados();
  buscarIndicador();
});


async function buscarIndicador() {

  if (!props.ClienteId) {
    controle.clienteIndicou = {} as service.Voucher;
    return;
  }

  console.log("buscar indicador", props.ClienteId);

  controle.status = "Buscando items...";
  controle.erro = "";
  service.obter({ indicadoId: props.ClienteId } as service.Filtros)
    .then((r) => {
      controle.clienteIndicou = r[0] || {} as service.Voucher;
      controle.status = "";
    })
    .catch((error) => {
      controle.erro = `Erro ao buscar items: ${error}`;
      controle.status = "";
    });
}

async function buscarIndicados() {

  if (!props.ClienteId) {
    controle.indicados = [];
    return;
  }

  console.log("buscar indicados", props.ClienteId);
  controle.status = "Buscando items...";
  controle.erro = "";
  service.obter({ indicadorId: props.ClienteId } as service.Filtros)
    .then((r) => {
      controle.indicados = r;
      controle.status = "";
    })
    .catch((error) => {
      controle.erro = `Erro ao buscar items: ${error}`;
      controle.status = "";
    });
}

async function salvar() {

  controle.status = "Salvando item...";
  controle.erro = "";

  if (controle.model.dataPagamento != null) {
    controle.model.dataPagamento = fdataUS(controle.model.dataPagamento);
  }

  controle.model.indicadorId = controle.clienteId ?? 0;

  service.salvar(controle.model)
    .then(() => {
      controle.status = "";
      controle.model = {
        indicadorId: props.ClienteId ?? 0,
      } as service.Voucher;
      buscarIndicados();
      controle.janela = false;
    })
    .catch((error) => {
      controle.erro = `Erro ao salvar item: ${error}`;
      controle.status = "";
    });
}

function excluir(item: service.Voucher) {
  controle.model = item;
  controle.janPergunta = true;
}

function excluirConfirma() {
  controle.janPergunta = false;
  controle.status = "Excluindo item...";
  controle.erro = "";

  service.excluir(controle.model.voucherId)
    .then(() => {
      controle.status = "";
      controle.model = {
        indicadorId: controle.model.indicadorId
      } as service.Voucher;
      buscarIndicados();
    })
    .catch((error) => {
      controle.erro = `Erro ao excluir item: ${error}`;
      controle.status = "";
    });
}

function statusTexto(status: number) {
  switch (status) {
    case 0:
      return "Aguardando Pagamento";
    case 1:
      return "Pago";
    case 2:
      return "Cancelado";
    default:
      return status;
  }
}

function statusBadge(status: number) {
  switch (status) {
    case 0:
      return "badge bg-warning";
    case 1:
      return "badge bg-success";
    case 2:
      return "badge bg-danger";
    default:
      return "badge bg-secondary";
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "card-title" }, "Vouchers")
          ], -1)),
          (!_unref(props).ClienteId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "row mb-2" }, [
                  _createElementVNode("div", { class: "col-md-12" }, [
                    _createElementVNode("p", { class: "" }, "Necessário cadastro do cliente")
                  ])
                ], -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_unref(controle).clienteIndicou.indicadorId != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-12" }, " Indicado por ", -1)),
                      _createElementVNode("div", _hoisted_5, [
                        _cache[4] || (_cache[4] = _createElementVNode("label", null, "Código", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).clienteIndicou.indicadorId) = $event)),
                          disabled: "",
                          readonly: ""
                        }, null, 512), [
                          [_vModelText, _unref(controle).clienteIndicou.indicadorId]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[5] || (_cache[5] = _createElementVNode("label", null, "Indicado por", -1)),
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          value: _unref(controle).clienteIndicou?.indicador?.nome,
                          disabled: "",
                          readonly: ""
                        }, null, 8, _hoisted_7)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[6] || (_cache[6] = _createElementVNode("label", null, "Data Cadastro", -1)),
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          value: _unref(fdataHora)(_unref(controle).clienteIndicou?.dataCadastro),
                          disabled: "",
                          readonly: ""
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", null, "Status", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["d-block badge", statusBadge(_unref(controle).clienteIndicou?.status)])
                        }, _toDisplayString(statusTexto(_unref(controle).clienteIndicou?.status)), 3)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row mb-2 mt-2" }, [
                  _createElementVNode("div", { class: "col-md-12" }, " Clientes Indicados (Indicações) ")
                ], -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("table", _hoisted_13, [
                      _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "text-end" }, "Cliente"),
                          _createElementVNode("th", null, "Nome"),
                          _createElementVNode("th", null, "Dt Pagamento"),
                          _createElementVNode("th", null, "CPF"),
                          _createElementVNode("th", null, "Celular"),
                          _createElementVNode("th", { class: "text-end" }, "Nro Voucher"),
                          _createElementVNode("th", null, "Status")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).indicados, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_14, _toDisplayString(item.indicadoId), 1),
                            _createElementVNode("td", null, _toDisplayString(item.indicado?.nome), 1),
                            _createElementVNode("td", null, _toDisplayString(_unref(fdataHora)(item.dataCadastro)), 1),
                            _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataPagamento)), 1),
                            _createElementVNode("td", null, _toDisplayString(item.status), 1),
                            _createElementVNode("td", _hoisted_15, _toDisplayString(item.voucherId), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["badge", statusBadge(item.status)])
                              }, _toDisplayString(statusTexto(item.status)), 3)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, "Registros: " + _toDisplayString(_unref(controle).indicados.length), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(controle).status), 1),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(controle).erro), 1)
                ])
              ]))
        ])
      ]),
      _: 1
    }),
    _createVNode(MsgBox, {
      id: 'janPerguntaVoucher',
      class: "modal-md",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janPergunta,
      titulo: 'Atenção',
      onOnFechou: _cache[1] || (_cache[1] = ($event: any) => (_unref(controle).janPergunta = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[2] || (_cache[2] = ($event: any) => (excluirConfirma()))
    }, {
      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
        _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 fs-5 fw-bold text-center" }, " Deseja excluir este registro ? ")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})